import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AutoCompleteDoubleControl } from '../../../form-models/autocomplete-double-control';
@Component({
  selector: 'hb-dynamic-auto-complete-double',
  templateUrl: './dynamic-auto-complete-double.component.html',
  styleUrls: ['./double-style.scss'],
})
export class DynamicAutoCompleteDoubleComponent {
  private _control: AutoCompleteDoubleControl;
  filteredOptionsLeft: any[] = [];
  filteredOptionsRight: any[] = [];

  @Input() formGroup: FormGroup;

  @Input() set control(control: AutoCompleteDoubleControl) {
    this._control = control;

    if (control && control.options && control.options.length > 0) {
      this.filteredOptionsLeft = control.options.map(x => x[this.control.leftFieldName]);
      this.filteredOptionsRight = control.options.map(x => x[this.control.rightFieldName]);
    }
  }

  @Output() onOverrideValue = new EventEmitter();

  get control(): AutoCompleteDoubleControl {
    return this._control;
  }

  constructor() {}

  public filterOptionsLeft(event): void {
    if (this.control && this.control.options && this.control.options.length > 0) {
      this.filteredOptionsLeft = this.control.options
        .filter(x => x[this.control.leftFieldName] && x[this.control.leftFieldName].toLowerCase().indexOf(event.query.toLowerCase()) === 0)
        .map(x => x[this.control.leftFieldName]);
      if (event.originalEvent.type === 'input') {
        this._control.leftOnChange(event.query);
      }
    }
  }

  public filterOptionsRight(event): void {
    if (this.control && this.control.options && this.control.options.length > 0) {
      this.filteredOptionsRight = this.control.options
        .filter(x => x[this.control.leftFieldName] && x[this.control.rightFieldName].toLowerCase().indexOf(event.query.toLowerCase()) === 0)
        .map(x => x[this.control.rightFieldName]);
      if (event.originalEvent.type === 'input') {
        this._control.rightOnChange(event.query);
      }
    }
  }

  public overrideValue(): void {
    this.onOverrideValue.emit();
  }
}
